import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { fmtInt } from '../../lib/format'
import { pct } from '../../lib/chartGeometry'

export interface FunnelStepBar {
  label: string
  value: number
  sub?: string
  href?: string
}

export function FunnelBars({ steps }: { steps: FunnelStepBar[] }) {
  const base = steps[0]?.value ?? 0
  const cols = steps.map((s) => {
    const body: ReactNode = (
      <>
        <span className="label">{s.label}</span>
        <span className="font-mono font-semibold text-3xl text-paper leading-none" style={{ fontVariantNumeric: 'tabular-nums slashed-zero' }}>
          {fmtInt(s.value)}
        </span>
        <div className="relative w-full bg-ink-600" style={{ height: 70 }} aria-hidden="true">
          <div className="absolute bottom-0 left-0 right-0" style={{ height: `${pct(s.value, base)}%`, background: '#ffb648' }} />
        </div>
        {s.sub && <span className="font-mono text-[12px] text-paper-faint">{s.sub}</span>}
      </>
    )
    const cls = 'flex flex-col gap-2 min-w-0'
    return s.href ? (
      <Link key={s.label} to={s.href} className={`${cls} hover:bg-ink-600`}>
        {body}
      </Link>
    ) : (
      <div key={s.label} className={cls}>
        {body}
      </div>
    )
  })
  return (
    <div className="overflow-x-auto">
      <div className="grid min-w-[440px] gap-3 md:min-w-0" style={{ gridTemplateColumns: 'repeat(5, minmax(0, 1fr))' }}>
        {cols}
      </div>
    </div>
  )
}
